import { CommunicationRecipient } from 'types/Communication';

export const getRecipientMails = (
  recipients: CommunicationRecipient[]
): string => {
  if (!recipients) return '';
  return recipients.map((recipient) => recipient.email).join(', ');
};
